<template>
    <BaseButton
        :button-text="tokens.newDesign.confirmWithdrawal"
        :button-style="'filled-primary'"
        :disabled="disabled"
        @click.native="requestWithdrawal"
    />
</template>

<script>
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"
import {NOTIFICATION_ERROR} from "@/store/mutations.type"
import {MINIMUM_WITHDRAWAL} from "@/common/config"
import {WITHDRAWAL_REQUEST} from "@/store/actions.type"
import {mapGetters} from "vuex"
import {withdrawalMethods, encodeNewLines} from "@/common/helpers"

export default {
    name: "SendWithdrawal",
    components: {BaseButton},
    props: {
        disabled: {
            type: Boolean,
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        requestWithdrawal() {
            let amount = String(this.info.amount)
            amount = amount.includes(',') ? amount.replace(/,/, '.') : amount;
            amount = parseFloat(amount);

            let pendingWithdrawals = 0;
            for (let n in this.withdrawals) {
                if (this.withdrawals[n].status === 0) {
                    pendingWithdrawals++;
                    if(pendingWithdrawals >= (parseInt(this.variables['PENDING_WITHDRAWALS_LIMIT']) || 1)){
                        this.$store.commit(NOTIFICATION_ERROR, this.tokens.errors['LOCAL_ONE_PENDING_WITHDRAWAL'].replace('{count}',((this.variables['PENDING_WITHDRAWALS_LIMIT']) || 1)))
                        return
                    }
                }
            }

            if (isNaN(parseFloat(amount))) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumWithdrawal + ' $' + MINIMUM_WITHDRAWAL)
                return
            }

            let activeAccountCurrency = this.info.activeAccount.currency?.toUpperCase();
            let currentAccountSymbol = this.symbols[(activeAccountCurrency)] || this.symbols[(activeAccountCurrency + 'USD')];
            let currentAccountSymbolRate = 1;

            if (currentAccountSymbol && currentAccountSymbol.quote && currentAccountSymbol.quote.bid) {
                currentAccountSymbolRate = currentAccountSymbol.quote.bid;
            }

            if (amount * currentAccountSymbolRate < MINIMUM_WITHDRAWAL) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumWithdrawal + ' $' + MINIMUM_WITHDRAWAL)
                return
            }

            let details = ''

            switch (this.info.method) {
                case 'bank':
                    details =
                        `Account: ${this.info.account}\nAccount holder: ${this.info.holder}${this.info.iban ? `\nIBAN: ` + this.info.iban : ''}${this.info.swift ? '\nSWIFT: ' + this.info.swift : ''}${this.info.recipientAddress ? '\nRecipient Address: ' + this.info.recipientAddress : ''}${this.info.routingNumber ? '\nRouting Number: ' + this.info.routingNumber : ''}${this.info.bankBeneficiary ? '\nBank of Beneficiary Name: ' + this.info.bankBeneficiary : ''}${this.info.bankAddress ? '\nBank Address: ' + this.info.bankAddress : ''}${this.info.bankCode ? '\nBank code (BSB): ' + this.info.bankCode : ''}${this.info.desc ? '\nDescription: ' + this.info.desc : ''}`
                    break
                case 'card':
                    details =
                        `Card: ${this.info.cardNumber}\nCard holder: ${this.info.name}`
                    break
                case 'zelle':
                    details = `Phone/Eamil:${this.info.contact}\nFull Name Zelle: ${this.info.name}`
                    break
            }

            let {cryptoMethods} = withdrawalMethods();

            if(cryptoMethods.some(i => i.name === this.info.method)){
                details = `${this.info.displayName}: ${this.info.wallet}`
            }

            let payload = {
                wallet: encodeNewLines(details),
                amount: amount,
                account_id: this.info.activeAccount.id,
                product: this.info.activeAccount.product,
                currency: this.info.activeAccount.currency
            }

            if(this.info.comment){
                payload.comment = this.info.comment
            }

            this.$store.dispatch(WITHDRAWAL_REQUEST, payload).then(() => {
                this.$emit('send')
            })
        },

    },
    computed: {
        ...mapGetters(['withdrawals', 'symbols','tokens','variables'])
    }
}
</script>


<style scoped>

</style>
